const tableColumns = [
  {
    title: 'Machine ID',
    dataIndex: 'machineid',
    key: 'machineid',
  },
  {
    title: 'Start Time',
    dataIndex: 'starttime',
    key: 'starttime',
  },
  {
    title: 'End Time',
    dataIndex: 'endtime',
    key: 'endtime',
  },
  {
    title: 'Pedal Count',
    dataIndex: 'pdcount',
    key: 'pdcount',
  },
  {
    title: 'Duration (seconds)',
    dataIndex: 'duration',
    key: 'duration',
  },
  {
    title: 'Phase Encoder Count',
    dataIndex: 'encodercount',
    key: 'encodercount',
    align: 'left',
  },
  // {
  //   title: 'Actions',
  //   dataIndex: 'action',
  //   key: 'action',
  //   width: '90px',
  // },
];

export { tableColumns };
